import React from 'react';
import {
  FooterWrapper,
  FooterContainer,
  FooterLogo,
  FooterMenuBar,
  FooterColumn,
  FooterTitle,
  FooterLink,
  FooterContent,
  FooterAddress,
  FooterCopyright,
  FooterInstagram,
  FooterLogoWrapper,
  MarketplaceLogo,
  MarketplaceLogoWrapper,
  FooterAnchorTag
} from './Footer.styled';

import logo from '../../assets/logo.png';
import { SiShopee, SiInstagram } from 'react-icons/si'
import TokopediaIcon from '../../assets/tokopedia-icon.png';
import { COMPANY_EMAIL, COMPANY_MOBILE_NO, INSTAGRAM_LINK, PRODUCT_CATEGORIES, SHOPEE_LINK, TIKTOK_LINK, TOKOPEDIA_LINK, WHATSAPP_LINK } from '../../utils/constants';
import kebabToTitleCase from '../../utils/kebabToTitleCase';
import { PRIMARY, SECONDARY } from '../../utils/colors'

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <FooterLogo>
          <img src={logo} alt="logo-gosyen" />
        </FooterLogo>

        <FooterMenuBar>
          <FooterColumn>
            <FooterTitle>Produk</FooterTitle>
            {PRODUCT_CATEGORIES.map((category) => {
              return (
                <FooterLink key={category} to={`/products?category=${category}`}>{kebabToTitleCase(category)}</FooterLink>
              )
            })}
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>
              <FooterAnchorTag href="#about">Our Company</FooterAnchorTag>
            </FooterTitle>
            <FooterLink to={{pathname: '/about-us', hash: '#video'}}>Company Profile</FooterLink>
            <FooterLink to="/about-us">Tentang Kami</FooterLink>
            <FooterLink to={{pathname: '/', hash: '#order-tutorial'}}>Cara Memesan</FooterLink>
            <FooterLink to="/faq">FAQ</FooterLink>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Cari Kami</FooterTitle>
            <FooterAnchorTag href={INSTAGRAM_LINK} target='_blank' rel='noopener noreferrer'>Instagram</FooterAnchorTag>
            <FooterAnchorTag href={TIKTOK_LINK} target='_blank' rel='noopener noreferrer'>TikTok</FooterAnchorTag>
            <FooterAnchorTag href={WHATSAPP_LINK} target='_blank' rel='noopener noreferrer'>WhatsApp</FooterAnchorTag>
          </FooterColumn>

          <FooterAddress>
            <FooterTitle>Informasi Kontak:</FooterTitle>
            <FooterContent>
              <p>
                <FooterAnchorTag onClick={() => window.open(WHATSAPP_LINK, '_blank', 'noopener,noreferrer')}>{COMPANY_MOBILE_NO} (WA)</FooterAnchorTag>
              </p>
              <p>
                <FooterAnchorTag href={`mailto:${COMPANY_EMAIL}`}>{COMPANY_EMAIL} (Email)</FooterAnchorTag>
              </p>
            </FooterContent>
          </FooterAddress>
        </FooterMenuBar>

        <FooterCopyright>
          <FooterLogoWrapper>
            <FooterInstagram onClick={() => window.open(INSTAGRAM_LINK, '_blank')} >
              <SiInstagram cursor='pointer' size={30} color={PRIMARY} />
              <FooterAnchorTag style={{marginBottom: 0}} href={INSTAGRAM_LINK} target='_blank' rel='noopener noreferrer'>
                Ikuti kami di Instagram
              </FooterAnchorTag>
            </FooterInstagram>
            {/* <MarketplaceLogoWrapper>
              <MarketplaceLogo src={TokopediaIcon} onClick={() => window.open(TOKOPEDIA_LINK, '_blank')}  />
              <SiShopee cursor='pointer' onClick={() => window.open(SHOPEE_LINK, '_blank')} size={30} color='#EE4D2D' />
            </MarketplaceLogoWrapper> */}
          </FooterLogoWrapper>
          
          <div>
            © 2025 MCUP | MCUP adalah merek milik PT. Maplas Putera Unggul Terdaftar pada Direktorat Jendral Kekayaan Intelektual Republik Indonesia.
          </div>
        </FooterCopyright>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer;
